export default {

  getMerchants ({ commit }, queryString) {
    // console.log('...getProducts(' + queryString + ')')
    return this.$axios.get(`/public/merchants/get${queryString}`).then((response) => {
      const {
        data,
        total,
        pages
      } = response.data
      commit('setMerchants', data)
      commit('setTotal', total)
      commit('setPages', pages)
    })
  }
}
